import { render } from "./CompanyPhoneQuotaSummary.vue?vue&type=template&id=4cbe5c98&ts=true"
import script from "./CompanyPhoneQuotaSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyPhoneQuotaSummary.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/whatsapp-meta/components/CompanyPhoneQuotaSummary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4cbe5c98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4cbe5c98', __exports__)) {
    api.reload('4cbe5c98', __exports__)
  }
  
  module.hot.accept("./CompanyPhoneQuotaSummary.vue?vue&type=template&id=4cbe5c98&ts=true", () => {
    api.rerender('4cbe5c98', render)
  })

}


export default __exports__